import { type StoreState } from '../../../store'
import { key } from './consent.reducer'

const getConsentStore = (state: StoreState) => state[key]

export const accepted = (state: StoreState) => getConsentStore(state).accepted
